import React from "react";
import SlotText from "../../invitation/SlotText";
import ExperienceCollectionArcFrame from "./ExperienceCollectionArcFrame";
import ExperienceCollectionCards from "./ExperienceCollectionCards";
import ExperienceCollectionQuote from "./ExperienceCollectionQuote";

// The moments: text slots `momentsHeading` here and the rest in the quote.
const ExperienceCollection = ({ id, joinUrl, arcImage, cardImages, ...rest }) => {
  return (
    <section className="section bottom-5" id={id} {...rest}>
      <div className="container">
        <div className="arc-header-div no-max">
          <SlotText slot="momentsHeading" as="h2" className="heading-9vw m-14" />
        </div>
        <ExperienceCollectionArcFrame image={arcImage} />
        <div className="home-collection">
          <div className="home-col-container">
            <ExperienceCollectionCards images={cardImages} />
            <ExperienceCollectionQuote joinUrl={joinUrl} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceCollection;
